<ion-content>

  <ion-header>
    <ion-toolbar mode="ios">
      <ion-button (click)="close()" fill="clear" color="dark" class="ion-no-padding">
        <ion-icon slot="icon-only" name="chevron-back"></ion-icon>
      </ion-button>
      <ion-title class="ion-no-padding">
        <ion-img [src]="dataServ.rData.dark_logo" *ngIf="dataServ.rData.dark_logo[0]"></ion-img>
      </ion-title>
    </ion-toolbar>
  </ion-header>

  <ion-grid class="form">

    <ion-row>
      <ion-col size="12">
        <ion-text color="primary" class="ion-text-center">
          <h1><b>{{'Add New Card' | translate}}</b></h1>
        </ion-text>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size="12">
        <ion-item>
          <ion-label position="stacked">{{'Card Name' | translate}}</ion-label>
          <ion-input [(ngModel)]="newData.cardName"></ion-input>
        </ion-item>
      </ion-col>

      <ion-col size="12">
        <ion-item>
          <ion-label position="stacked">{{'Cardholder Name' | translate}}</ion-label>
          <ion-input [(ngModel)]="newData.cardHolderName"></ion-input>
        </ion-item>
      </ion-col>

      <ion-col size="12">
        <ion-item>
          <ion-label position="stacked">{{'Card Number' | translate}}</ion-label>
          <ion-input [(ngModel)]="newData.cardNo"></ion-input>
        </ion-item>
      </ion-col>

      <ion-col size="4">
        <ion-item>
          <ion-label position="stacked">{{'Month' | translate}}</ion-label>

          <ion-select [(ngModel)]="newData.month">
            <ion-select-option value="01">01</ion-select-option>
            <ion-select-option value="02">02</ion-select-option>
            <ion-select-option value="03">03</ion-select-option>
            <ion-select-option value="04">04</ion-select-option>
            <ion-select-option value="05">05</ion-select-option>
            <ion-select-option value="06">06</ion-select-option>
            <ion-select-option value="07">07</ion-select-option>
            <ion-select-option value="08">08</ion-select-option>
            <ion-select-option value="09">09</ion-select-option>
            <ion-select-option value="10">10</ion-select-option>
            <ion-select-option value="11">11</ion-select-option>
            <ion-select-option value="12">12</ion-select-option>
          </ion-select>
        </ion-item>
      </ion-col>

      <ion-col size="4">
        <ion-item>
          <ion-label position="stacked">{{'Year' | translate}}</ion-label>

          <ion-select [(ngModel)]="newData.year">
            <ion-select-option value="21">21</ion-select-option>
            <ion-select-option value="22">22</ion-select-option>
            <ion-select-option value="23">23</ion-select-option>
            <ion-select-option value="24">24</ion-select-option>
            <ion-select-option value="25">25</ion-select-option>
            <ion-select-option value="26">26</ion-select-option>
            <ion-select-option value="27">27</ion-select-option>
            <ion-select-option value="28">28</ion-select-option>
            <ion-select-option value="29">29</ion-select-option>
            <ion-select-option value="30">30</ion-select-option>
            <ion-select-option value="31">31</ion-select-option>
            <ion-select-option value="32">32</ion-select-option>
            <ion-select-option value="33">33</ion-select-option>
            <ion-select-option value="34">34</ion-select-option>
            <ion-select-option value="35">35</ion-select-option>
            <ion-select-option value="36">36</ion-select-option>
            <ion-select-option value="37">37</ion-select-option>
            <ion-select-option value="38">38</ion-select-option>
            <ion-select-option value="39">39</ion-select-option>
          </ion-select>
        </ion-item>
      </ion-col>

      <ion-col size="4">
        <ion-item>
          <ion-label position="stacked">{{'CCV' | translate}}</ion-label>
          <ion-input [(ngModel)]="newData.ccv"></ion-input>
        </ion-item>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size="12">
        <ion-button (click)="save()" expand="block" color="primary">
          {{'Save' | translate}}
        </ion-button>
      </ion-col>
    </ion-row>

  </ion-grid>
</ion-content>